export enum PayrollResponseCodes {
    SUCCESS_OPERATION = 60000,
    EMPLOYER_NOT_REGISTERED_IN_NE = 60001,
    EMPLOYER_PILA_TOKEN_AUTH_ERROR = 60002,
    EMPLOYER_STATUS_UPDATE_ERROR = 60003,
    EMPLOYER_DOCUMENT_ASSIGN_ERROR = 60004,
    PAYMENT_UPDATE_ERROR = 60005,
    NOT_SUPPORTED_STATUS_CODE = 60006,
    FREE_EMPLOYER_STATUS_UPDATE_ERROR = 60007,
    EMPLOYER_HAS_NOT_ELECTRONIC_PAYRROLL_FOR_UPDATED = 60008,
    INTERNAL_SERVER_ERROR = 69999,
}
